import React, { Component } from "react";
import Sound from "./components/Sound";

import "./App.css";

const sounds = [
  {
    an: "Goeienavond iedereen",
    wv: "Goeinavond iederjeen",
    src: require("./mp3/goeienavond.mp3")
  },
  {
    an: "Papa, mag ik een fruitsapje ajb",
    wv: "Pa, meuk a frutsapke ijn osteblieft",
    src: require("./mp3/fruitsapje.mp3")
  },
  {
    an: "Welterusten meisje",
    wv: "Slapwel he meiske",
    src: require("./mp3/slaapwel.mp3")
  },
  {
    an: "Goeiendag iedereen",
    wv: "Elks ne goeindag iederjéne",
    src: require("./mp3/goeiendag.mp3")
  },
  {
    an: "Ja, dat heb ik",
    wv: "Joak",
    src: require("./mp3/jadathebik.mp3")
  },
  {
    an: "Nee, dat heb ik niet",
    wv: "Nink",
    src: require("./mp3/needathebikniet.mp3")
  },
  {
    an: "Het is hier echt mooi",
    wv: "Amai, tis ier vree skoone",
    src: require("./mp3/mooi.mp3")
  },
  {
    an: "Welk dier is dat?",
    wv: "Wukken beeste is dadde?",
    src: require("./mp3/dier.mp3")
  },
  {
    an: "Voor mij zo’n biertje graag",
    wv: "Voo mie zukke pinte osteblieft",
    src: require("./mp3/pintje.mp3")
  },
  {
    an: "Tot straks",
    wv: "Tot te fète",
    src: require("./mp3/totstraks.mp3")
  },
  {
    an: "Wees voorzichtig he meisje",
    wv: "Zi voorzichtig é meistjeuh",
    src: require("./mp3/voorzichrig.mp3")
  },
  {
    an: "Ik heb geen idee",
    wv: "Kij gin gedacht",
    src: require("./mp3/idee.mp3")
  },
  {
    an: "Ik wil een boterham met choco",
    wv: "Kwil a stuutje me choco",
    src: require("./mp3/chico.mp3")
  },
  {
    an: "Kijk eens hier zeg",
    wv: "Kik ne kjè ier",
    src: require("./mp3/kijk.mp3")
  },
  {
    an: "Zitten we hier ver van de zee?",
    wv: "Zitn wier verre van de zjé",
    src: require("./mp3/zee.mp3")
  },
  {
    an: "Waarom is mama niet mee?",
    wv: "Vo wuk is moeder ni mé?",
    src: require("./mp3/mama.mp3")
  }
];

class App extends Component {
  render() {
    return (
      <div className="App">{sounds.map(s => <Sound key={s.an} {...s} />)}</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js